import { format, parse } from "date-fns";
import * as R from "ramda";
import { useLocation } from "react-router-dom";
import { PERSON_ROUTES } from "routes/pathnames";

export function parseJson(params) {
  try {
    return JSON.parse(params);
  } catch (error) {
    return error;
  }
}
export function mergeLovs(a, b) {
  const d = a;
  for (let i = 0; i < d.length; i++) {
    for (let j = 0; j < b.length; j++) {
      if (d[i].name === b[j].name) {
        d[i] = { ...d[i], ...b[j] };
      }
    }
  }
  return d;
}

export function keyValueList(data, key) {
  const lov = x => ({ label: x, value: x });
  const label = x => x[key];
  return R.is(Array, data) ? R.compose(R.sortBy(R.prop("label")), R.map(lov), R.uniq(), R.map(label))(data) : [];
}

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

// encode and decode url params
export function GetDecodedQueryParams() {
  const query = useQuery();
  const q = query.get("q");
  let params = "";
  try {
    params = atob(q);
  } catch (e) {
    // decode error catch
  }
  return new URLSearchParams(params);
}

export function getEncodedQueryParams(urlPath, params) {
  const encodedData = btoa(params);
  return `${urlPath}?q=${encodedData}`;
}

export function usePathName() {
  const location = useLocation();
  if (location && location.pathname) {
    return location.pathname;
  }
  return null;
}
const yesNo = a => (a ? "Yes" : "No");
function replaceBool(a) {
  if (typeof a === "boolean") {
    return yesNo(a);
  }
  if (typeof a === "object" && a !== null) {
    return R.map(replaceBool, a);
  }
  return a;
}
export const transformBool = data => R.map(replaceBool, data);

export const getGAId = () => {
  const GACode = type => {
    try {
      return JSON.parse(process.env.REACT_APP_GA)[type];
    } catch (e) {
      return "";
    }
  };
  const websiteEnv = window.location.hostname;
  let gaTrackingId = "";
  if (websiteEnv.search("unit-") >= 0) {
    gaTrackingId = GACode("UNIT");
  } else if (websiteEnv.search("uat-") >= 0) {
    gaTrackingId = GACode("UAT");
  } else if (websiteEnv.search("ci-") >= 0 || websiteEnv.search("localhost") >= 0) {
    gaTrackingId = GACode("CI");
  } else if (websiteEnv.search("test-") >= 0) {
    gaTrackingId = GACode("TEST");
  } else {
    gaTrackingId = GACode("PROD");
  }
  return gaTrackingId;
};

export function replaceKeys(obj) {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    const newKey = key.toUpperCase();
    newObj[newKey] = typeof obj[key] === "string" ? R.trim(obj[key]) : obj[key];
  });
  return newObj;
}

export const setIsEditingFlag = () => {
  document.body.setAttribute("data-is-editing", true);
};

export const removeIsEditingFlag = () => {
  document.body.removeAttribute("data-is-editing");
};

export function getPassThroughURL(app, param) {
  const url = `${process.env.REACT_APP_ORIGIN}core-service/system/core/auth/ROSTERING/relay/${app}?relayState=${param}`;
  return url;
}

export const toCamel = str => str.replace(/[-_]([a-z])/g, m => m[1].toUpperCase());
export const snakeCase = str => str.replace(/([A-Z])/g, x => R.concat("_", x.toLowerCase()));

export const toCamelCase = o => {
  if (R.is(Object, o)) {
    const n = {};

    Object.keys(o).forEach(k => {
      n[toCamel(k)] = toCamelCase(o[k]);
    });

    return n;
  }
  if (R.is(Array, o)) {
    return o.map(i => toCamelCase(i));
  }

  return o;
};
// should use for stable keys such as input fieds and editable data
export const generateKey = (pre, post) => `${pre}_${new Date().getTime()}_${post}`;

export function transformYN(params) {
  switch (params) {
    case "Yes":
      return "true";
    case "No":
      return "false";
    default:
      return params;
  }
}

// will open the given URL in the new browser TAB
export function openInNewTab(url) {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  link.click();
  link.remove();
}

export function keysToSnake(obj) {
  if (R.is(Object, obj)) {
    const newObj = {};
    Object.keys(obj).forEach(k => {
      newObj[snakeCase(k)] = keysToSnake(obj[k]);
    });
    return newObj;
  }
  return obj;
}
export function getRandomValues() {
  const crypto = window.crypto || window.msCrypto;
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
}

export function removeConsecutiveDuplicates(array) {
  const result = [];

  for (let i = 0; i < array.length; i++) {
    if (array[i] !== array[i + 1]) {
      result.push(array[i]);
    }
  }

  return result;
}

export function normalizeNull(data) {
  if (Array.isArray(data)) {
    return data.map(item => (item === null || item === undefined) ? "" : item);
  }
  return data;
}

export function normalizeNullObject(data) {
  if (data === null || data === undefined || Object.keys(data).length === 0) {
    return {};
  } else {
    return data;
  }
}

export function dispatchRefreshEvent() {
  const refreshEvent = new CustomEvent("refresh", {
    bubbles: true,
    cancelable: true
  });
  document.dispatchEvent(refreshEvent);
}
export const getEncodePersonUrl = (ctepId, userGroup) =>
  getEncodedQueryParams(
    PERSON_ROUTES.AFFILIATION,
    `ctepid=${ctepId}&userGroup=${userGroup}`
  );

export const toLower = (str = "") => str.toLowerCase();
export const toTitle = (str) => str.toLowerCase().replace(/_/g, " ");
export const toTooltip = (t) => `${t.taskType}: ${t.taskCount} ${toTitle(t.taskStatus)} records `;

export function formatMyTaskData(data) {
  const list = [{
    "title": "Credentialing",
    "tasks": []
  }, {
    "title": "Institutions",
    "tasks": []
  }, {
    "title": "People",
    "tasks": []
  }];
  if (!Array.isArray(data)) {
    return list;
  }
  return data?.reduce((acc, curr) => {
    const existing = acc.find((item) => item.title === curr.taskType);
    if (existing) {
      existing.tasks.push({
        taskType: curr.taskType,
        rosterOwner: curr.rosterOwner,
        count: curr.taskCount,
        status: toLower(curr.taskStatus),
        title: toTitle(curr.taskStatus),
        taskStatus: curr.taskStatus,
        tooltip: toTooltip(curr)
      });
    } else {
      acc.push({
        title: curr.taskType,
        tasks: [
          {
            taskType: curr.taskType,
            rosterOwner: curr.rosterOwner,
            count: curr.taskCount,
            status: toLower(curr.taskStatus),
            title: toTitle(curr.taskStatus),
            taskStatus: curr.taskStatus,
            tooltip: toTooltip(curr)
          }
        ]
      });
    }
    return acc;
  }, list).map(item => ({
    ...item,
    tasks: item?.tasks.sort((a, b) => a.status.localeCompare(b.status))
  }));
}

export function getPendingCountFromMyTask(data = [], title) {
  const items = data.find((item) => item.title === title);
  const item = items && items.tasks.find(task => task.status === "pending");
  return item && item.count ? item.count : 0;
}

export function getBeforeParentheses(str) {
  const match = str.match(/(.*?)\s*\(/);
  return match ? match[1] : str;
}

export function toggleExpandedTree(list, userGroup) {
  if (!Array.isArray(list)) {
    return list;
  }
  return list?.map(item => {
    const labelGroup = getBeforeParentheses(item.node_label);
    if (labelGroup === userGroup) {
      item.expanded = "Y";
    } else {
      item.expanded = "N";
    }
    return item;
  });
}
export function hasSubstringCaseInsensitive(text, searchSubstring) {
  return text.toLowerCase().includes(searchSubstring.toLowerCase());
}

export const isZipRequired = (cnyId) => {
  console.log(cnyId);
  return typeof cnyId === "string" ? ["228", "37", "15"].includes(cnyId) : [228, 37, 15].includes(cnyId);
};

export const toSentence = (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const renderYN = (rowData, key) => {
  if (rowData[key] === "") {
    return "";
  } else if (rowData[key] === true) {
    return "Yes";
  } else {
    return "No";
  }
};

export const formatDate = (dateString, f) => {
  const date = parse(dateString, f, new Date());
  return format(date, "dd-MMM-yyyy");
};

export const formatCurrency = (value) => {
  if (!value) return "";

  const numericValue = String(value).replace(/[^0-9.]/g, "");
  if (numericValue) {
    return new Intl.NumberFormat("en-US", {
      currency: "USD",
      style: "currency",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numericValue);
  }
  return "";
};

export const formatAsCurrency = (value) => {
  if (!value) return "";

  const numericValue = String(value).replace(/[^0-9.]/g, "");
  if (numericValue) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true
    }).format(numericValue);
  }
  return "";
};

export const currencyToNumber = (value) => {
  if (!value) return "";

  const numericValue = String(value).replace(/[^0-9.]/g, "");
  return numericValue;
};
